import { useMemo } from 'react'
import { zoomLevelValues } from '#store/layoutConfiguration'
import { useSharedAppSelector } from '#store/sharedBaseStore'

export const useWindowZoom = () => {
  const zoom = useSharedAppSelector((x) => x.layoutConfiguration.zoom.zoom)
  return useMemo(() => {
    const value = zoomLevelValues[zoom]
    return {
      level: zoom,
      value: value,
      inverse: 1.0 / value,
    }
  }, [zoom])
}
